import { useState } from "react";
import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "i18n";

import {
  addRecentAirport,
  clearRecentAirports,
  excludeAirportsByCityCode,
  getRecentAirports,
} from "utils/recentAirports";

const AirportResults = ({ query, results, loading, onSelect, excludeCityCode }) => {
  const { t } = useTranslation();
  const [recents, setRecents] = useState(getRecentAirports);
  const hasQuery = (query || "").trim().length >= 2;
  const visibleRecents = excludeAirportsByCityCode(recents, excludeCityCode);
  const visibleResults = excludeAirportsByCityCode(results, excludeCityCode);
  const showRecents = !hasQuery && visibleRecents.length > 0;
  const items = hasQuery ? visibleResults : visibleRecents;

  const handleSelect = (item) => {
    if (
      excludeCityCode &&
      String(item?.cityCode || "").trim().toUpperCase() ===
        String(excludeCityCode).trim().toUpperCase()
    ) {
      return;
    }
    addRecentAirport(item);
    onSelect(item);
  };

  if (hasQuery && loading) {
    return (
      <div className="airport-search__loading">
        {[...Array(3)].map((_, index) => (
          <div className="airport-search__skeleton" key={index}>
            <Skeleton variant="rounded" width={44} height={44} />
            <div className="airport-search__skeleton-copy">
              <Skeleton variant="text" width="55%" height={22} />
              <Skeleton variant="text" width="80%" height={18} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!hasQuery && !showRecents) {
    return (
      <div className="airport-search__empty">
        <FlightTakeoffRoundedIcon />
        <p>{t("search.airportSearchHint")}</p>
        <span>{t("search.exampleLocation")}</span>
      </div>
    );
  }

  if (hasQuery && items.length === 0) {
    return (
      <div className="airport-search__empty">
        <FlightTakeoffRoundedIcon />
        <p>{t("search.airportNoResults")}</p>
        <span>{t("search.exampleLocation")}</span>
      </div>
    );
  }

  return (
    <>
      {showRecents && (
        <div className="airport-search__recents-header">
          <span className="airport-search__recents-title">
            <HistoryRoundedIcon />
            {t("search.recentAirports")}
          </span>
          <button
            type="button"
            className="airport-search__recents-clear"
            onClick={() => setRecents(clearRecentAirports())}
          >
            {t("common.clear")}
          </button>
        </div>
      )}
      <div className="result-search-wrapper">
        {items.map((item, index) => (
          <button
            key={`${item?.cityCode || item?.cityName}-${index}`}
            type="button"
            className="airport-search__item"
            onClick={() => handleSelect(item)}
          >
            <span className="airport-search__code">
              {item?.cityCode || "—"}
            </span>
            <span className="airport-search__copy">
              <strong>{item?.cityName}</strong>
              <span>
                {item?.airportName}
                {item?.countryName ? ` · ${item.countryName}` : ""}
              </span>
            </span>
            <span className="airport-search__select">{t("common.select")}</span>
          </button>
        ))}
      </div>
    </>
  );
};

export default AirportResults;
